import React, { useEffect, useState } from 'react';
import { useI18n } from '../lib/i18n';
import { Menu, X } from 'lucide-react';
export function Nav() {
  const {
    t,
    lang,
    setLang
  } = useI18n();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollTo = (id: string) => {
    setMobileMenuOpen(false);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const navLinks = [{
    id: 'marco',
    label: t('nav.marco')
  }, {
    id: 'aplicaciones',
    label: t('nav.aplicaciones')
  }, {
    id: 'motor',
    label: t('nav.motor')
  }, {
    id: 'timeline',
    label: t('nav.timeline')
  }, {
    id: 'papers',
    label: t('nav.papers')
  }, {
    id: 'autor',
    label: t('nav.autor')
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-background/80 backdrop-blur-md border-b border-white/5 py-3' : 'bg-transparent py-5'}`} data-id="element-131">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-132">
        {/* Logo */}
        <div className="flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} data-id="element-133">
          <span className="font-display text-2xl tracking-tight text-white" data-id="element-134">
            CLVN–LRR™
          </span>
        </div>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-135">
          <div className="flex items-center gap-6" data-id="element-136">
            {navLinks.map(link => <button key={link.id} onClick={() => scrollTo(link.id)} className="text-sm text-gray-400 hover:text-white transition-colors" data-id="element-137">
                {link.label}
              </button>)}
          </div>

          <div className="flex items-center gap-4 border-l border-white/10 pl-4" data-id="element-138">
            <button onClick={() => setLang(lang === 'es' ? 'en' : 'es')} className="text-xs font-mono text-gray-400 hover:text-white transition-colors uppercase tracking-widest" data-id="element-139">
              {lang === 'es' ? 'EN' : 'ES'}
            </button>

            <button onClick={() => scrollTo('papers')} className="text-sm font-medium bg-white text-black px-4 py-1.5 rounded-full hover:bg-gray-200 transition-colors" data-id="element-140">
              {t('nav.leerPaper')}
            </button>
          </div>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-gray-400 hover:text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-141">
          {mobileMenuOpen ? <X size={24} data-id="element-142" /> : <Menu size={24} data-id="element-143" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-surface border-b border-white/5 p-6 flex flex-col gap-4" data-id="element-144">
          {navLinks.map(link => <button key={link.id} onClick={() => scrollTo(link.id)} className="text-left text-lg text-gray-300 hover:text-white" data-id="element-145">
              {link.label}
            </button>)}
          <div className="h-px bg-white/10 my-2" data-id="element-146" />
          <div className="flex items-center justify-between" data-id="element-147">
            <button onClick={() => setLang(lang === 'es' ? 'en' : 'es')} className="text-sm font-mono text-gray-400 hover:text-white uppercase tracking-widest" data-id="element-148">
              {lang === 'es' ? 'Switch to English' : 'Cambiar a Español'}
            </button>
            <button onClick={() => scrollTo('papers')} className="text-sm font-medium bg-white text-black px-4 py-2 rounded-full" data-id="element-149">
              {t('nav.leerPaper')}
            </button>
          </div>
        </div>}
    </nav>;
}